export const REORDER_CATEGORY = 'REORDER_CATEGORY';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
